<template>
  <div>
    <v-btn flat icon color="#444444">
      <v-icon>share</v-icon>
    </v-btn>
    {{ share }}
  </div>
</template>

<script>
export default {
  props: {
    share: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.v-btn {
  margin: 0;
}
</style>